/**
 * Request/response schemas for the caller's own UI-language preference, `GET`/`PATCH
 * /api/profile/locale` (`server/src/auth/localeRoutes.ts`). Same self-service shape as
 * `signatureRequests.ts`'s own pair — this file holds the wire shapes both `server/` and `web/`
 * validate against, `server/src/db/schema/platform.ts`'s `users.locale` column holds storage.
 */

import { z } from 'zod';

import { isLocale, SUPPORTED_LOCALES } from './locale.ts';

export const localeSchema = z.custom<(typeof SUPPORTED_LOCALES)[number]>(
  (value) => typeof value === 'string' && isLocale(value),
  { message: `must be one of: ${SUPPORTED_LOCALES.join(', ')}` },
);

/** `null` clears the preference back to browser-detected — a real, distinct value from "field
 * omitted," so this is `nullable()` rather than `optional()`, and the field is always required in
 * the body: there is nothing else this one-field endpoint could mean by omitting it. */
export const updateLocaleRequestSchema = z.strictObject({
  locale: localeSchema.nullable(),
});
export type UpdateLocaleRequest = z.infer<typeof updateLocaleRequestSchema>;

export const localeSettingsResponseSchema = z.strictObject({
  locale: localeSchema.nullable(),
});
export type LocaleSettingsResponse = z.infer<typeof localeSettingsResponseSchema>;
